import { Fade } from '@mui/material';

import AuthLayout from 'layouts/auth-layout';

import Banner from './components/banner';
import IndividualForm from './components/individual-form';

const SignUpPage = () => {
  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          <Banner />
          <IndividualForm />
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default SignUpPage;
